import { render, staticRenderFns } from "./creatingChannel.vue?vue&type=template&id=0abeed1e&scoped=true&lang=pug"
import script from "./creatingChannel.vue?vue&type=script&lang=js"
export * from "./creatingChannel.vue?vue&type=script&lang=js"
import style0 from "./creatingChannel.vue?vue&type=style&index=0&id=0abeed1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abeed1e",
  null
  
)

export default component.exports